/**
 * Keyboard focus as an opaque 2px `--ring` outline drawn inside the element, so
 * a container that clips its overflow cannot cut it off.
 */
export const focusOutline =
  "focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-ring";

/**
 * For a control filled in the ring's own colour: the outline is drawn wholly on
 * the fill, in the fill's label colour, so it contrasts as the label does.
 */
export const focusOutlineOnPrimary =
  "focus-visible:-outline-offset-4 focus-visible:outline-primary-foreground";

export const focusOutlineOnDestructive =
  "focus-visible:-outline-offset-4 focus-visible:outline-destructive-foreground";
